<div style="margin-top: 50px">
   <a href="https://catchsoftware.com/our-products/frankly/" target="_blank">About Frankly base edition</a>
  <div style="display: flex; align-items: center; margin-top: 15px">
    {{ prompts.version }}
  </div>
</div>
